import { registerPlugin, PluginListenerHandle } from '@capacitor/core';

export interface CarSpotPayload {
  id: string;
  name: string;
  spotType: string;
  latitude: number;
  longitude: number;
  score: number;
  suitabilityColor: string;
  distanceMeters: number;
  isDriveable: boolean;
}

export interface CarRoutePayload {
  coordinates: [number, number][]; // [lat, lon] pairs
  distance: number;
  duration: number;
  destinationName: string;
}

export interface FricampCarPlugin {
  updateNearbySpots(options: { spots: CarSpotPayload[] }): Promise<void>;
  showRoute(options: CarRoutePayload): Promise<void>;
  clearRoute(): Promise<void>;
  updatePosition(options: { latitude: number; longitude: number; heading: number }): Promise<void>;
  setMapStyle(options: { style: 'topo' | 'satellite' | 'hybrid' }): Promise<void>;
  isConnected(): Promise<{ connected: boolean }>;

  addListener(event: 'spotSelected', handler: (data: { spotId: string }) => void): Promise<PluginListenerHandle>;
  addListener(event: 'navigateToSpot', handler: (data: { spotId: string; latitude: number; longitude: number }) => void): Promise<PluginListenerHandle>;
  addListener(event: 'connectionChanged', handler: (data: { connected: boolean }) => void): Promise<PluginListenerHandle>;
}

const noopPlugin: FricampCarPlugin = {
  updateNearbySpots: async () => {},
  showRoute: async () => {},
  clearRoute: async () => {},
  updatePosition: async () => {},
  setMapStyle: async () => {},
  isConnected: async () => ({ connected: false }),
  addListener: async () => ({ remove: async () => {} }),
};

export const FricampCar = registerPlugin<FricampCarPlugin>('FricampCar', {
  web: noopPlugin,
});
